export const GAME_FULL_RANGE_RULER_COUNT = new Array(100).fill(null).map((item, index) => index);

export const minRangeValue = 0;

export const maxRangeValue = 99;

export const rangeMinStep = 1;

export const rangeDefaultValue = 50;

export const marketTypes = {
  Under: 0,
  Over: 1,
};
